import React from 'react';
import { Modal } from 'antd';

import { DocumentReference } from '@totem/components/documents/types';
import DocumentsLinkPanel from '@totem/components/documents/upload/documentsLinkPanel';
import ModalTitle from '@totem/components/ui_components/dialogs/ModalTitle';

type Props = {
  visible: boolean;
  onClose: (refresh: boolean) => void;
  reference: DocumentReference;
};

const DocumentsLinkDialog = ({ visible, onClose, reference }: Props) => {
  return (
    <Modal
      open={visible}
      onCancel={() => onClose(false)}
      title={<ModalTitle>Document Link</ModalTitle>}
      confirmLoading={false}
      width={'60%'}
      footer={null}
    >
      <DocumentsLinkPanel onClose={onClose} reference={reference} />
    </Modal>
  );
};

export default DocumentsLinkDialog;
